import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Nuevo Staff", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_CreateForm = _resolveComponent("CreateForm")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
    : (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ModuleHeader, null, {
            title: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_CreateForm, {
            formData: _ctx.person,
            isLoading: _ctx.isLoading
          }, null, 8, ["formData", "isLoading"])
        ]))
      : _createCommentVNode("", true)
}